<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<div class="tit">
<h1 class="titlepage"><span class="lighter">A LIFE WORTH LIVING</span><br/>THE 9 ESSENTIALS</h1>
</div>
<br/><br/><br/>
<p class="center"><span class="big2"><strong>BARRIE SANFORD GREIFF, M.D.</strong></span><br/>Previously published under the title <em>Legacy</em></p>
<br/><br/><br/><br/><br/><br/><br/><br/>
<p class="center"><img alt="" src="OEBPS/images/logo1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062046253_epub_tp_r1.vue?1a9c70b4